// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drb9xyGGUIu0cUaFWZvA {
  background-color: hsl(250, 73%, 12%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem 0;
}
.drb9xyGGUIu0cUaFWZvA h2 {
  padding: 0;
  color: white;
  font-weight: 600;
  font-size: 2rem;
  margin: 1rem 0;
}
.drb9xyGGUIu0cUaFWZvA h2 .EQu69p76q_8iPPOFQTXM {
  text-decoration: overline hsl(232, 100%, 64%);
  font-size: 1em;
}
.drb9xyGGUIu0cUaFWZvA .ogPFCJHEWoOWIJg07ize {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}
.drb9xyGGUIu0cUaFWZvA .ogPFCJHEWoOWIJg07ize a {
  color: white;
  font-size: 2rem;
  transition: transform 200ms ease-in-out;
}
.drb9xyGGUIu0cUaFWZvA .ogPFCJHEWoOWIJg07ize a:hover {
  color: hsl(232, 100%, 64%);
  transform: scale(1.1);
}
.drb9xyGGUIu0cUaFWZvA .EJAVu23nIi2V9PiXSmCM {
  margin-top: 2rem;
  color: gray;
}`, "",{"version":3,"sources":["webpack://./src/footer/index.module.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAGA;EACC,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAFD;AAGC;EACC,UAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AADF;AAEE;EACC,6CAAA;EACA,cAAA;AAAH;AAGC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AADF;AAEE;EACC,YAAA;EACA,eAAA;EACA,uCAAA;AAAH;AACG;EACC,0BChCQ;EDiCR,qBAAA;AACJ;AAGC;EACC,gBAAA;EACA,WAAA;AADF","sourcesContent":["@use \"../scss/colors.scss\";\n@use \"../scss/media.scss\" as *;\n\n.container {\n\tbackground-color: colors.$dark;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 1rem 0;\n\th2 {\n\t\tpadding: 0;\n\t\tcolor: white;\n\t\tfont-weight: 600;\n\t\tfont-size: 2rem;\n\t\tmargin: 1rem 0;\n\t\t.overline {\n\t\t\ttext-decoration: overline colors.$secondary;\n\t\t\tfont-size: 1em;\n\t\t}\n\t}\n\t.contact {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\twidth: 100%;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 2rem;\n\t\ta {\n\t\t\tcolor: white;\n\t\t\tfont-size: 2rem;\n\t\t\ttransition: transform 200ms ease-in-out;\n\t\t\t&:hover {\n\t\t\t\tcolor: colors.$secondary;\n\t\t\t\ttransform: scale(1.1);\n\t\t\t}\n\t\t}\n\t}\n\t.copyrights {\n\t\tmargin-top: 2rem;\n\t\tcolor: gray;\n\t}\n}\n","$primary: hsl(249, 68%, 15%);\n$secondary: hsl(232, 100%, 64%);\n$ternary: hsl(221, 66%, 94%);\n\n$dark: hsl(250, 73%, 12%);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `drb9xyGGUIu0cUaFWZvA`,
	"overline": `EQu69p76q_8iPPOFQTXM`,
	"contact": `ogPFCJHEWoOWIJg07ize`,
	"copyrights": `EJAVu23nIi2V9PiXSmCM`
};
export default ___CSS_LOADER_EXPORT___;
